import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FileModel, ItemsToBeRemovedOptions } from '@ca/core/models';

@Component({
    selector: 'ca-folder-item-submenu',
    templateUrl: './folder-item-submenu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FolderItemSubmenuComponent {
    @Input() isRenameBtnEnabled = false;
    @Input() isDeleteBtnEnabled = false;
    @Input() isShareBtnEnabled = false;
    @Input() fileModel: FileModel;

    @Output() openChange = new EventEmitter<boolean>();
    @Output() renameFolder = new EventEmitter<FileModel>();
    @Output() deleteItems = new EventEmitter<ItemsToBeRemovedOptions<FileModel>>();
    @Output() openSharing = new EventEmitter<FileModel>();

    onRename(): void {
        this.renameFolder.emit(this.fileModel);
    }

    onDelete(): void {
        this.deleteItems.emit({ items: [this.fileModel], shouldConfirmDialogBeOpened: true });
    }

    onShare(): void {
        this.openSharing.emit(this.fileModel);
    }
}
